import { ExpandLess, ExpandMore } from '@mui/icons-material';
import FindInPage from '@mui/icons-material/FindInPage';
import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt';
import {
    Box,
    Button,
    CircularProgress,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';

import Configuracao from '../../util/Configuracao';
import ReactComponent from '../ReactComponent';

class ModalPendenciasSessao extends ReactComponent {
    modalPendenciasAberto = false;
    sessoesPendencias;
    listaColapsada;

    abrirModalPendencias = async () => {
        const sessoesPendencias = await this.salaSessaoStore.recuperarPendenciasSessao();
        runInAction(() => {
            this.sessoesPendencias = sessoesPendencias;
            this.modalPendenciasAberto = true;
            this.listaColapsada = new Map();
        });
    };

    fecharModalPendencias = () => {
        this.modalPendenciasAberto = false;
        this.sessoesPendencias = undefined;
        this.listaColapsada = undefined;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            agruparPendenciasPorTipo: true,
            compareMagistrado: true,
            compareProcesso: true,
            statusDaSessao: true,
            render: true,
            renderPendenciasPorSessao: true,
            modalPendenciasAberto: observable,
            sessoesPendencias: observable,
            listaColapsada: observable,
            abrirModalPendencias: action,
            fecharModalPendencias: action,
            pendenciasAgrupadas: computed,
            possiveisPendenciasAgrupadas: computed,
            trocarColapsaExpand: action
        });
    }

    agruparPendenciasPorTipo(tipoPossiveisPendencias) {
        const retorno = {};
        let pendenciasAgrupadas;

        if (this.sessaoStore.sessaoSelecionada && this.sessoesPendencias && this.sessoesPendencias.length > 0) {
            this.sessoesPendencias.forEach((sessao) => {
                pendenciasAgrupadas = {
                    quantidadeProcessosPendentes: 0,
                    pendenciasSemResponsavel: [],
                    pendenciasRelator: new Map(),
                    pendenciasRedator: new Map(),
                    relatoresSorted: [],
                    redatoresSorted: []
                };
                let listagemPendencias = tipoPossiveisPendencias
                    ? sessao.possiveisPendenciasProcessos
                    : sessao.pendenciasProcessos;
                listagemPendencias = listagemPendencias ? listagemPendencias : [];
                pendenciasAgrupadas.quantidadeProcessosPendentes = listagemPendencias.length;

                listagemPendencias.forEach((processoPendente) => {
                    const processoNaSessao = this.salaSessaoStore.processosSessao.find((processo) => {
                        return processoPendente.numeroProcesso === processo.processo.numeroCompleto;
                    });

                    if (processoNaSessao) {
                        const relator = processoNaSessao.processo.relator;
                        const redator = processoNaSessao.processo.redator;

                        if (relator) {
                            if (!pendenciasAgrupadas.pendenciasRelator.has(relator.sigla)) {
                                pendenciasAgrupadas.pendenciasRelator.set(relator.sigla, []);
                                pendenciasAgrupadas.relatoresSorted.push(relator);
                            }
                            pendenciasAgrupadas.pendenciasRelator.get(relator.sigla).push(processoPendente);
                        } else {
                            if (redator) {
                                if (!pendenciasAgrupadas.pendenciasRedator.has(redator.sigla)) {
                                    pendenciasAgrupadas.pendenciasRedator.set(redator.sigla, []);
                                    pendenciasAgrupadas.redatoresSorted.push(redator);
                                }
                                pendenciasAgrupadas.pendenciasRedator.get(redator.sigla).push(processoPendente);
                            } else {
                                pendenciasAgrupadas.pendenciasSemResponsavel.push(processoPendente);
                            }
                        }
                    }
                });

                // Ordenando Relatores e processos de cada Relator
                pendenciasAgrupadas.relatoresSorted.sort(this.compareMagistrado);
                pendenciasAgrupadas.relatoresSorted.forEach((relator) => {
                    pendenciasAgrupadas.pendenciasRelator.get(relator.sigla).sort(this.compareProcesso);
                });

                // Ordenando Redatores e processos de cada Redator
                pendenciasAgrupadas.redatoresSorted.sort(this.compareMagistrado);
                pendenciasAgrupadas.redatoresSorted.forEach((redator) => {
                    pendenciasAgrupadas.pendenciasRedator.get(redator.sigla).sort(this.compareProcesso);
                });
                retorno[sessao.sessao] = pendenciasAgrupadas;
            });
        }
        return retorno;
    }

    get pendenciasAgrupadas() {
        return this.agruparPendenciasPorTipo(false);
    }

    get possiveisPendenciasAgrupadas() {
        return this.agruparPendenciasPorTipo(true);
    }

    compareMagistrado(magA, magB) {
        if (magA.nome < magB.nome) {
            return -1;
        }
        if (magA.nome > magB.nome) {
            return 1;
        }
        return 0;
    }

    compareProcesso(procA, procB) {
        if (procA.numeroProcesso < procB.numeroProcesso) {
            return -1;
        }
        if (procA.numeroProcesso > procB.numeroProcesso) {
            return 1;
        }
        return 0;
    }

    get statusDaSessao() {
        return this.sessaoStore.sessaoSelecionada && this.sessaoStore.sessaoSelecionada.situacao;
    }

    trocarColapsaExpand(nomeListagem) {
        const valorAtual = this.listaColapsada.get(nomeListagem);
        runInAction(() => {
            this.listaColapsada.set(nomeListagem, !valorAtual);
        });
        return true;
    }

    render() {
        return (
            <>
                {this.statusDaSessao === Configuracao.STATUS_INICIADA || this.sessaoStore.existeSessaoSIJ ? (
                    <Tooltip
                        placement="top-start"
                        title="Listar Pendências"
                    >
                        <Box
                            className="corBotaoAmarelo"
                            onClick={this.abrirModalPendencias}
                            style={{ display: 'flex', margin: '8px', cursor: 'pointer', fill: 'white' }}
                        >
                            <FindInPage />
                        </Box>
                    </Tooltip>
                ) : null}
                {(this.statusDaSessao === Configuracao.STATUS_INICIADA || this.sessaoStore.existeSessaoSIJ) &&
                this.modalPendenciasAberto ? (
                    <Dialog
                        maxWidth="md"
                        onClose={this.fecharModalPendencias}
                        open={this.modalPendenciasAberto}
                    >
                        <DialogTitle>Pendências da Sessão</DialogTitle>
                        <DialogContent>
                            {this.sessoesPendencias === undefined ? (
                                <div>
                                    Aguarde... <CircularProgress size={25} />
                                </div>
                            ) : (
                                <>
                                    {Object.keys(this.pendenciasAgrupadas).length > 0 ? (
                                        this.renderPendenciasPorSessao(false)
                                    ) : (
                                        <div>Não Há pendências</div>
                                    )}
                                    {Object.keys(this.possiveisPendenciasAgrupadas).length > 0 ? (
                                        this.renderPendenciasPorSessao(true)
                                    ) : (
                                        <div>Não Há possíveis pendências</div>
                                    )}
                                </>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="primary"
                                endIcon={<ThumbUpAlt />}
                                onClick={this.fecharModalPendencias}
                                variant="contained"
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                ) : null}
            </>
        );
    }

    renderPendenciasPorSessao(tipoPossiveisPendencias) {
        const retorno = [];
        const listagemPendencias = tipoPossiveisPendencias
            ? this.possiveisPendenciasAgrupadas
            : this.pendenciasAgrupadas;
        const mensagem = tipoPossiveisPendencias ? ' - Possíveis pendências' : ' - Pendências';

        for (const key in listagemPendencias) {
            const sessao = listagemPendencias[key];
            const nomeListagem = key + (tipoPossiveisPendencias ? '-pendencias' : '-possiveisPendencias');

            if (!this.listaColapsada.has(nomeListagem)) {
                this.listaColapsada.set(nomeListagem, true);
            }
            if (sessao.quantidadeProcessosPendentes > 0) {
                retorno.push(
                    <Box key={this.nextKey}>
                        <Box
                            onClick={this.trocarColapsaExpand.bind(this, nomeListagem)}
                            sx={{ fontWeight: 'bold' }}
                        >
                            {'Sessão ' +
                                key.replaceAll('-', ' ') +
                                mensagem +
                                ' (' +
                                sessao.quantidadeProcessosPendentes +
                                ')'}
                            {this.listaColapsada.get(nomeListagem) ? <ExpandMore /> : <ExpandLess />}{' '}
                        </Box>
                        <Collapse
                            unmountOnExit
                            in={this.listaColapsada.get(nomeListagem)}
                            timeout="auto"
                        >
                            {sessao.pendenciasRelator.size > 0 && (
                                <ul>
                                    {sessao.relatoresSorted.map((relator) => {
                                        return (
                                            <li key={this.nextKey}>
                                                <Typography>Relator {relator.nome}</Typography>
                                                <ul>
                                                    {sessao.pendenciasRelator.get(relator.sigla).map((processo) => {
                                                        return (
                                                            <li key={this.nextKey}>
                                                                <Typography>{processo.numeroProcesso}</Typography>
                                                                <ul>
                                                                    {processo.pendencias.map((pendencia) => {
                                                                        return (
                                                                            <li key={this.nextKey}>
                                                                                <Typography>
                                                                                    {
                                                                                        this.dominioStore
                                                                                            .tiposPendenciasFechamento[
                                                                                            pendencia
                                                                                        ].descricao
                                                                                    }
                                                                                </Typography>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                            {sessao.pendenciasRedator.size > 0 && (
                                <ul>
                                    {sessao.redatoresSorted.map((redator, index) => {
                                        return (
                                            <li key={index}>
                                                <Typography>Redator {redator.nome}</Typography>
                                                <ul>
                                                    {sessao.pendenciasRedator
                                                        .get(redator.sigla)
                                                        .map((processo, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <Typography>{processo.numeroProcesso}</Typography>
                                                                    <ul>
                                                                        {processo.pendencias.map((pendencia) => {
                                                                            return (
                                                                                <li key={this.nextKey}>
                                                                                    <Typography>
                                                                                        {
                                                                                            this.dominioStore
                                                                                                .tiposPendenciasFechamento[
                                                                                                pendencia
                                                                                            ].descricao
                                                                                        }
                                                                                    </Typography>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                    </ul>
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                            {sessao.pendenciasSemResponsavel.length > 0 && (
                                <ul>
                                    <li key="0">
                                        <Typography>Processos sem Relator ou Redator</Typography>
                                        <ul>
                                            {sessao.pendenciasSemResponsavel.map((processo) => {
                                                return (
                                                    <li key={this.nextKey}>
                                                        <Typography>---{processo.numeroProcesso}</Typography>
                                                        <ul>
                                                            {processo.pendencias.map((pendencia, index) => {
                                                                return (
                                                                    <li key={index}>
                                                                        <Typography>
                                                                            ------
                                                                            {
                                                                                this.dominioStore
                                                                                    .tiposPendenciasFechamento[
                                                                                    pendencia
                                                                                ].descricao
                                                                            }
                                                                        </Typography>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </li>
                                </ul>
                            )}
                        </Collapse>
                    </Box>
                );
            }
        }
        return retorno;
    }
}

export default inject('stores')(observer(ModalPendenciasSessao));
